import * as React from 'react';
import { flow } from 'lodash';
import { destroy } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { IHeaderActions } from './models';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { Col, Row } from 'react-bootstrap';
import { IStore } from '../../../../redux/IStore';
import { actions as headerActions } from './reducer';
import { IChannel } from '../../../../data/api/models';
import { IAuthState } from '../../../../services/auth/models';
import { IQuoteActions } from '../../../../services/quote/models';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';

interface IHeaderProps {
  classes: any;
  isDrawerOpened: boolean;
  actions: {
    auth: IAuthActions;
    quote: IQuoteActions;
    header: IHeaderActions;
    destroy(formName: string);
    push: (route: string) => void;
  };
  steps: object;
  location: any;
  auth: IAuthState;
  channel: IChannel;
}

interface IHeaderState {
  showModal: boolean;
}

class Header extends React.Component<IHeaderProps, IHeaderState> {
  private handleLogoClick = () => {
    const { actions } = this.props;

    actions.quote.reset();
    actions.destroy('quote');
    actions.push('/');
  }

  private renderLogo = () => {
    const { channel } = this.props;

    if (channel.channelType === 'AGG' && channel.channelLogo) {
      return (
        <div className="logo-container">
          <div className="channel-logo-solo">
            <img src={channel.channelLogo} alt={channel.name} />
          </div>
        </div>
      );
    }

    if (channel.channelType === 'AGG' && !channel.channelLogo && channel.additionalLogo) {
      return (
        <div className="logo-container">
          <div className="logo-link">
            <img src={require('./img/rcp_logo.png')} alt="eRCpro" />
          </div>
          <div className="logo-divider" />
          <div className="agg-logo">
            <img src={channel.additionalLogo} alt={channel.name} />
          </div>
        </div>
      );
    }

    return (
      <div className="logo-container">
        <div className="logo-link" onClick={this.handleLogoClick}>
          <img src={require('./img/rcp_logo.png')} alt="eRCpro" />
        </div>
        <div className="logo-title link" onClick={this.handleLogoClick}>
          <strong className={'white'}>e</strong>RCpro
        </div>
      </div>
    );
  }

  private handleSignOut = () => {
    const { actions } = this.props;

    actions.auth.logout();
  }

  private renderAuthLinks = () => {
    const { location, auth } = this.props;
    const isInLoginPage = location.pathname === '/auth/login';
    const isInCustomerArea = location.pathname.match(/(account)/);

    if (isInLoginPage) {
      return null;
    }

    if (isInCustomerArea) {
      return (
        <a onClick={this.handleSignOut}>
          Déconnexion
        </a>
      );
    }

    return (
      <Link to="/auth/login">
        {auth.isAuthenticated ? 'Mon compte' : 'Connexion client'}
      </Link>
    );
  }

  public render() {
    const { channel } = this.props;

    return (
      <header>
        <div className="main-header">
          <div className="container">
            <Row>
              <Col md={4}>
                  {this.renderLogo()}
              </Col>
              <Col md={8}>
                <div className="main-header-links">
                  {this.props.channel.live && (
                    <ul>
                      <li>
                        <Link to="/who-we-are">
                          Qui sommes-nous?
                        </Link>
                      </li>
                      <li>
                        <Link to="/contacts">
                          Contacts
                        </Link>
                      </li>
                      <li>
                        <Link to="/useful-links">
                          Lien utiles
                        </Link>
                      </li>
                      <li>
                        <Link to="/faq">
                          FAQ
                        </Link>
                      </li>
                      <li>
                        {this.renderAuthLinks()}
                      </li>
                    </ul>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </header>
    );
  }
}

export default flow([
  connect(
    (state: IStore) => ({
      auth: state.auth,
      channel: state.branding.channel,
      isDrawerOpened: state.header.isDrawerOpened,
    }),
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        destroy: bindActionCreators(destroy, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
        header: bindActionCreators({ ...headerActions }, dispatch),
      },
    }),
  ),
  withRouter,
])(Header);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Shell/scenes/Header/index.tsx